import { Block, Button, LogOut01, useStyletron } from "@mezo-org/mezo-clay";
import React, { useCallback } from "react";
import { useDisconnect } from "wagmi";
import { useSignOut } from "../../../hooks";
import WalletAddress from "./WalletAddress";
import AccountBalance from "./AccountBalance";
import WelcomeBlock from "./WelcomeBlock";
import AccountAddressActions from "./AccountAddressActions";
import AccountAssetItem from "./AccountAssetItem";
import { formatNumberToCompactString } from "../../../utils/numbers";
import { formatUsd } from "../../../utils/currency";
import AccountOtherAssets from "./AccountOtherAssets";
export default function Root(props) {
    const { mezoId, walletAddress, accountAddress, walletType, usdTotalBalance, usdTroveDebt, usdCollateral, matsBalance, assets, otherAssetsCount, otherAssetsUsdTotal, onSignOut, onOtherAssetsClick, } = props;
    const [, theme] = useStyletron();
    const { disconnect } = useDisconnect();
    const { signOut } = useSignOut();
    const handleLogOut = useCallback(() => {
        if (onSignOut) {
            onSignOut();
            return;
        }
        signOut();
        disconnect();
    }, [signOut, disconnect, onSignOut]);
    const formattedMatsBalance = formatNumberToCompactString(matsBalance, 2);
    const formattedUsdTotalBalance = formatUsd(usdTotalBalance);
    const formattedUsdTroveDebt = formatUsd(usdTroveDebt);
    const formattedUsdCollateral = formatUsd(usdCollateral);
    return (React.createElement(Block, { display: "inline-flex", flexDirection: "column", padding: theme.sizing.scale600 },
        React.createElement(WelcomeBlock, { mezoId: mezoId, matsBalance: formattedMatsBalance }),
        React.createElement(AccountAddressActions, { address: accountAddress }),
        React.createElement(Block, { display: "flex", flexDirection: "column", backgroundColor: theme.colors.backgroundSecondary, overflow: "hidden", overrides: {
                Block: { style: { borderRadius: theme.borders.radius300 } },
            } },
            React.createElement(WalletAddress, { address: walletAddress, type: walletType }),
            React.createElement(AccountBalance, { totalBalance: formattedUsdTotalBalance, totalDebt: formattedUsdTroveDebt }),
            React.createElement(AccountAssetItem, { type: "BTC", amount: assets.btc.formattedUsdBalance, subLabel: "Locked collateral", subValue: formattedUsdCollateral }),
            React.createElement(AccountAssetItem, { type: "MUSD", amount: assets.musd.formattedUsdBalance, subLabel: "Borrowed", subValue: formattedUsdTroveDebt }),
            React.createElement(AccountOtherAssets, { assetsCount: otherAssetsCount, assetsUsdTotal: otherAssetsUsdTotal, onClick: onOtherAssetsClick })),
        React.createElement(Block, { marginTop: theme.sizing.scale700, padding: `0 ${theme.sizing.scale100}` },
            React.createElement(Button, { size: "small", kind: "tertiary", startEnhancer: React.createElement(LogOut01, { color: "currentColor", size: 12 }), onClick: () => handleLogOut(), overrides: {
                    Root: {
                        style: {
                            ":hover": {
                                backgroundColor: theme.colors.backgroundSecondary,
                                boxShadow: "none",
                            },
                            ":active": {
                                backgroundColor: theme.colors.backgroundSecondary,
                                color: theme.colors.contentPrimary,
                            },
                        },
                    },
                } }, "Log out"))));
}
//# sourceMappingURL=Root.js.map